module.exports = __webpack_public_path__ + "img/renewed.c054693a.png";